import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//引入axios依赖
import axios from 'axios'
axios.defaults.baseURL = 'https://www.msucce.com:443/api'
// axios.defaults.baseURL = '/api'

const app = createApp(App) // 将默认改写为这样
app.config.globalProperties.$axios = axios


//elementplus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}


app.use(store).use(router).use(ElementPlus).mount('#app')
